export default __webpack_public_path__ + "static/media/LIttoBG.bd1cecc5.jpg";